var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('primary-page',{attrs:{"title":"Q & A","sub-title":"遇到问题，轻松解决","keywords":_vm.keywords,"routes":_vm.defRoutes},on:{"search":_vm.handleSearch}},[_c('q-a-tab',{ref:"QATabList",on:{"askQuestion":_vm.showAskQuestion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }